<template>
  <div class="options__title">
    <span class="title">
      {{ title }}
    </span>
    <div class="title_after_before"></div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'TitleOptions',
  props: ['title']
})
export default class TitleOptionsComponent extends Vue {}
</script>

<style lang="scss" scoped>
.options__title {
  display: flex;
  margin: 32px 0;
  .title {
    font-family: 'Ubuntu-Regular';
    font-size: $sixteenSize;
    color: $servicesTitle;
  }
  .title_after_before {
    position: relative;
    &::after {
      content: '';
      position: absolute;
      top: 7px;
      left: 25px;
      width: 150px;
      height: 1px;
      background: $ligher-grey;
    }
    &::before {
      content: '';
      position: absolute;
      top: 5px;
      left: 20px;
      width: 5px;
      height: 5px;
      border-radius: 8px;
      background: $ligher-grey;
    }
  }
}
</style>
